import $ from 'jquery';
import 'imagesloaded';
import ShopifyVariants from 'shopify-variants';

import { updateMiniCart } from '../utils/mini-cart';
import { twitterSharing, googlePlusSharing } from '../utils/sharing';

import ThemeUtils from '../ThemeUtils';

export default class Product {
  constructor(component) {
    this.el = component.el;
    this.$el = $(this.el);
    this.data = component.data;
    this.onScroll = this.onScroll.bind(this);
    this.setupProductDetails = this.setupProductDetails.bind(this);

    this.window = $(window);
    this.productArea = $('.product-area', this.el);
    this.fullscreenViewer = $('.fullscreen-product-viewer', this.el);
    this.fullscreenModal = this.fullscreenViewer.find('.modal');
    this.thumbsCount = this.productArea.find('.thumb').length;
    this.productZoom = $('.product-zoom', this.el);

    this.productImages = this.productArea.find('.product-images');
    this.productMainImage = $('.product-main-image', this.el);
    this.zoomArea = $('.product-zoom', this.el);
    this.productDetailsWrapper = this.productArea.find('.product-details-wrapper');
    this.productDetails = this.productArea.find('.product-details');

    this.selectedThumbIndex = 0;
    this.processing = false;

    // Loop through featured image (or all images in list mode) and prepare zoom if enabled
    if (this.productZoom.length) {
      $.each(
        this.productMainImage,
        (index, elem) => $(elem).imagesLoaded(() => this.prepareZoom($(elem), $(elem).find('.product-zoom'))),
      );
    }

    this.window.on('shopify-variants:switch-variant.product', (event, data) => this._onVariantSwitch(data.product, data.variant));

    this.setupVariants();

    twitterSharing();
    googlePlusSharing();

    this.fullscreenViewer.find('.showcase .container').spin('small');

    if (this.data.thumbOrientation === 'list') {
      this.window.on('load.product resize.product', ThemeUtils.debounce(this.setupProductDetails, 100));
      this.window.on('scroll.product', ThemeUtils.debounce(this.onScroll, 10));
    }

    this.window.on('resize.product', () => this.resize());
    this.window.on('prepare-zoom.product', this.prepareZoom.bind(this));

    $('.product-area .thumb', this.el).on('click.product', this.determineSelectedThumb.bind(this));
    $('.fullscreen-product-viewer .thumb', this.el).on('click.product', this.determineSelectedThumb.bind(this));
    $('.toggle-fullview', this.el).on('click.product', this.openFullview.bind(this));
    $('.fullscreen-product-viewer', this.el).on('click.product', this.closeFullview.bind(this));
    $('.fullscreen-product-viewer .modal', this.el).on('click.product', event => event.stopPropagation());
    $('.product-area .submit', this.el).on('click.product', this.addProductToCart.bind(this));
    $('.modal-wrap .close', this.el).on('click.product', this.closeFullview.bind(this));
    $('.product-area .single-option-selector', this.el).on('change.product', this.resetErrors.bind(this));
    $('.product-main-image.zoom-enabled', this.el).on('click.product', this.toggleZoom.bind(this));
    $('.product-zoom', this.el).on('mouseout.product', this.resetZoom.bind(this));
    $('.product-zoom', this.el).on('mousemove.product', this.zoomImage.bind(this));
    $('.product-main-image', this.el).on('resetZoom.product', this.resetZoom.bind(this));
  }

  setupVariants() {
    this.$options = this.$el.find('[data-product-option]');
    this.$variants = this.$el.find('[data-variants]');

    this.variantHelpers = new ShopifyVariants(this.data.product, this.$variants, this.$options);

    const labels = this.productArea.find('.inline-field-wrapper > label');
    if (labels.length > 1) {
      let width = 0;
      for (let i = 0; i < labels.length; i++) {
        const $label = $(labels[i]);
        if ($label.width() > width) { width = $label.width(); }
      }

      labels.width(width);
    }
  }

  onScroll() {
    if (
      (document.documentElement.offsetWidth > 770) &&
      (document.documentElement.clientHeight > this.detailsHeight)
    ) {
      this.positionProductInfo(this.stickyNavHeight, this.detailsWrapperOffset, this.detailsHeight);
    } else {
      this.productDetails.css('position', 'static');
    }
  }

  resize() {
    this.formatTheModal();
    return this.resizeShowcase();
  }

  setupProductDetails() {
    this.mainHeaderWrap = $('.main-header-wrap');

    this.productDetails.width(this.productDetailsWrapper.width());

    if (this.mainHeaderWrap.attr('data-header-format') !== 'minimal') {
      this.stickyNavHeight = 0;
      this.detailsWrapperOffset = this.productDetailsWrapper.offset().top - this.stickyNavHeight;
      this.detailsHeight = this.productDetails.outerHeight(true) + this.stickyNavHeight;
    } else {
      this.stickyNavHeight = $('.header-minimal').outerHeight(true);
      this.detailsWrapperOffset = this.productDetailsWrapper.offset().top;
      this.detailsHeight = this.productDetails.outerHeight(true);
    }

    return this.onScroll();
  }

  positionProductInfo(stickyNavHeight, detailsWrapperOffset, detailsHeight) {
    const scrollTop = this.window.scrollTop() + stickyNavHeight;
    const detailsTop = this.productDetails.offset().top;
    let detailsBottom = detailsTop + detailsHeight;
    let imagesBottom = this.productImages.offset().top + this.productImages.outerHeight(true);

    if (this.productDetails.outerHeight() >= this.productImages.outerHeight(true)) { return; }

    const makeStatic = () => this.productDetails.css({
      position: 'static',
      bottom: '',
      top: '',
    });

    const makeAbsolute = () => this.productDetails.css({
      position: 'absolute',
      bottom: 0 + this.productArea.css('padding-bottom'),
      top: 'auto',
    });

    const makeFixed = () => this.productDetails.css({
      position: 'fixed',
      top: stickyNavHeight,
      bottom: '',
    });

    detailsBottom = this.productDetails.offset().top + detailsHeight;
    imagesBottom = this.productImages.offset().top + this.productImages.outerHeight(true);

    // We're not far enough down the page for any changes yet
    if ((detailsWrapperOffset - scrollTop) >= 0) {
      makeStatic();
      return;
    }

    // We're too far down the page and going back up
    if ((this.productImages.offset().top < scrollTop) && ((detailsTop - scrollTop) > 0)) {
      makeFixed();
      return;
    }

    if (
      !((detailsBottom + 1) >= imagesBottom) ||
      !(imagesBottom < (scrollTop + this.window.height()))
    ) {
      makeFixed();
    } else {
      makeAbsolute();
    }
  }

  handleErrors(response) {
    const error = JSON.parse(response.responseText);
    const submitButton = $('[data-product-form] .submit', this.el);

    $('[data-product-form]', this.el).append(`<div class="error-message">${error.description}</div>`);

    this.timeout = setTimeout(() => {
      this.processing = false;
      submitButton
        .val(submitButton.data('original-text'))
        .removeClass('disabled');
    }, 2000);
  }

  resetErrors() {
    $('.error-message', this.el).remove();
    this.processing = false;
  }

  addProductToCart(e) {
    e.preventDefault();
    if (this.processing) { return; }

    // Connect error handler
    // We need to do this each time because the quickshop might override it
    Shopify.onError = XMLHttpRequest => this.handleErrors(XMLHttpRequest);

    this.resetErrors();

    const submitButton = $(e.currentTarget);
    submitButton
      .data('original-text', submitButton.val())
      .val(Theme.pleaseWait)
      .addClass('disabled');
    this.processing = true;

    Shopify.addItemFromForm(this.data.product.id, () => {
      if (this.data.productSettings.cartRedirect) {
        window.location = '/cart';
        return;
      }

      Shopify.getCart(cart => updateMiniCart(cart));
      submitButton.val(Theme.addedToCart);

      this.timeout2 = setTimeout(() => {
        submitButton
          .val(submitButton.data('original-text'))
          .removeClass('disabled');
        this.processing = false;
      }, 2000);
    });
  }

  resizeShowcase() {
    const container = this.productArea.find('.container');
    const imgHeight = container.find('img').height();

    if (this.productImages.attr('data-thumb-orientation') !== 'list') {
      container.height(imgHeight);
    }
  }

  openFullview() {
    $('body').css({ overflow: 'hidden' });
    this.fullscreenViewer.show();
    this.formatTheModal();

    this.fullscreenViewer.fadeTo(300, 1, () => {
      // Synchronize product showcases
      this.parent = this.fullscreenModal;

      if (this.thumbsCount > 0) {
        this.updateProductShowcase();
      }
    });

    $(document).bind('keyup', (e) => {
      // Bind the close function to the 'esc' key
      if (e.keyCode === 27) { this.closeFullview(); }
    });
  }

  closeFullview(e) {
    if ((e == null) || (e.target === e.currentTarget)) {
      this.fullscreenViewer.fadeTo(300, 0, () => {
        // Synchronize product showcases
        this.parent = this.productArea;

        if (this.thumbsCount > 0) {
          this.updateProductShowcase();
        }

        this.fullscreenViewer.hide();
        $('body').css({ overflow: 'auto' });
      });

      $(document).unbind('keyup');
    }
  }

  formatTheModal() {
    const container = this.fullscreenModal.find('.container');
    const imgHeight = container.find('img').height();
    container.height(imgHeight);

    this.scroller = this.fullscreenViewer.find('.pager').antiscroll({ autoHide: false }).data('antiscroll');

    this.fullscreenViewer.find('.pager').height(imgHeight).one('transitionend', () => this.scroller.refresh());

    return container.imagesLoaded(() => this.verticallyAlignModal());
  }

  verticallyAlignModal(imageHeight) {
    let modalHeight;
    const windowHeight = $(window).height();
    if (imageHeight) {
      modalHeight = imageHeight + 118;
    } else {
      modalHeight = this.fullscreenModal.outerHeight();
    }

    if (windowHeight <= modalHeight) {
      this.fullscreenModal.css({ 'margin-top': 0 });
    } else {
      const offset = (windowHeight - modalHeight) / 2;
      this.fullscreenModal.css({ 'margin-top': offset });
      this.timeout3 = setTimeout(
        () => $('.fullscreen-product-viewer .modal', this.el).addClass('transitions-are-go')
        , 50,
      );
    }
  }

  determineSelectedThumb(e) {
    this.selectedThumbIndex = ($(e.currentTarget)).index();
    if (this.fullscreenViewer.is(':visible')) {
      this.parent = $('.modal-wrap', this.el);
    } else {
      this.parent = this.productArea;
    }
    return this.updateProductShowcase();
  }

  updateProductShowcase() {
    const showcaseContainer = this.parent.find('.showcase .container');
    const showcaseWrap = showcaseContainer.find('.wrap');
    const showcaseImage = showcaseContainer.find('img');

    showcaseContainer.height(showcaseImage.height());

    const activeThumb = this.parent.find('.thumb.active');
    const selectedThumb = this.parent.find('.thumb').eq(this.selectedThumbIndex);
    const selectedImg = selectedThumb.find('img');
    const src = selectedImg.data('high-res-url');

    if (this.selectedThumbIndex !== activeThumb.index()) {
      let img = new Image();
      img.src = src;
      img = $(img);

      const animationSpeed = 200;

      showcaseWrap.fadeTo(animationSpeed, 0, () => {
        showcaseImage.remove();
        this.resetZoom();
        img.imagesLoaded(() => {
          showcaseWrap.append(img);
          this.prepareZoom(this.productMainImage, this.zoomArea);
          showcaseContainer.animate(
            { height: img.height() },
            animationSpeed, 'linear', () => {
              activeThumb.removeClass('active');
              selectedThumb.addClass('active');
              showcaseWrap.fadeTo(animationSpeed, 1);
            },
          );

          if (this.fullscreenViewer.is(':visible')) {
            this.verticallyAlignModal(img.height());
            this.fullscreenViewer.find('.pager').height(img.height()).one('transitionend', () => this.scroller.refresh());
          }
        });
      });
    }
  }

  prepareZoom($productImage, $productZoomArea) {
    if (!$productZoomArea.length) { return; }

    const photoAreaWidth = $productImage.width();
    const photoAreaHeight = $productImage.height();

    const newZoomImage = new Image();

    $(newZoomImage).on('load', () => {
      this.zoomImageWidth = newZoomImage.width;
      this.zoomImageHeight = newZoomImage.height;

      const ratios = [];
      ratios[0] = this.zoomImageWidth / photoAreaWidth;
      ratios[1] = this.zoomImageHeight / photoAreaHeight;

      const ratio = Math.max(...ratios);

      // Only enable the zoom if a certain zooming ratio is met.
      if (ratio < 1.4) {
        $productImage.removeClass('zoom-enabled');
      } else {
        $productImage.addClass('zoom-enabled');

        $productZoomArea.css({ backgroundImage: `url(${newZoomImage.src})` });
      }
    });

    newZoomImage.src = $productImage.find('img').attr('src');
  }

  resetZoom() {
    return this.zoomArea
      .removeClass('active')
      .css('background-position', '');
  }

  toggleZoom(e) {
    if (this.productMainImage.hasClass('zoom-enabled')) {
      if (e.type === 'mouseout') {
        this.zoomArea.removeClass('active');
        this.resetZoom();
        return;
      }

      ($(e.currentTarget)).find('.product-zoom').toggleClass('active');

      this.zoomImage(e);
    }
  }

  zoomImage(e) {
    let $productImage;
    let $productZoomArea;

    if (($(e.currentTarget)).hasClass('product-main-image')) {
      $productImage = ($(e.currentTarget));
      $productZoomArea = $productImage.find('.product-zoom');
    } else {
      $productZoomArea = ($(e.currentTarget));
      $productImage = $productZoomArea.parent('.product-main-image');
    }

    const zoomWidth = $productZoomArea.width();
    const zoomHeight = $productZoomArea.height();

    const bigImageOffset = $productImage.offset();
    const bigImageX = Math.round(bigImageOffset.left);
    const bigImageY = Math.round(bigImageOffset.top);

    const mousePositionX = e.pageX - bigImageX;
    const mousePositionY = e.pageY - bigImageY;

    // Make sure our mouse position is still inside our box.
    if (
      (mousePositionX < zoomWidth) && (mousePositionY < zoomHeight) &&
      (mousePositionX > 0) && (mousePositionY > 0)
    ) {
      if ($productZoomArea.hasClass('active')) {
        const theImage = new Image();
        theImage.src = $productImage.find('img').attr('src');

        this.zoomImageWidth = theImage.width;
        this.zoomImageHeight = theImage.height;

        // Figure out how to position the zoomed image.
        let ratioX = -1 * Math.round((
          ((mousePositionX / zoomWidth) * this.zoomImageWidth) - (zoomWidth / 2)
        ));
        let ratioY = -1 * Math.round((
          ((mousePositionY / zoomHeight) * this.zoomImageHeight) - (zoomHeight / 2)
        ));

        if (ratioX > 0) { ratioX = 0; }
        if (ratioY > 0) { ratioY = 0; }

        if (ratioX < -(this.zoomImageWidth - zoomWidth)) {
          ratioX = -(this.zoomImageWidth - zoomWidth);
        }

        if (ratioY < -(this.zoomImageHeight - zoomHeight)) {
          ratioY = -(this.zoomImageHeight - zoomHeight);
        }

        const newBackgroundPosition = `${ratioX}px ${ratioY}px`;

        $productZoomArea.css({ backgroundPosition: newBackgroundPosition });
      }
    }
  }

  unload() {
    clearTimeout(this.timeout);
    clearTimeout(this.timeout2);
    clearTimeout(this.timeout3);
    this.window.off('load.product resize.product');
    this.window.off('scroll.product');
    this.window.off('resize.product');
    this.window.off('prepare-zoom.product');
    this.window.off('shopify-variants:switch-variant.product');
    $('.product-area .thumb', this.el).off('click.product');
    $('.fullscreen-product-viewer .thumb', this.el).off('click.product');
    $('.toggle-fullview', this.el).off('click.product');
    $('.fullscreen-product-viewer', this.el).off('click.product');
    $('.fullscreen-product-viewer .modal', this.el).off('click.product');
    $('.product-area .submit', this.el).off('click.product');
    $('.modal-wrap .close', this.el).off('click.product');
    $('.product-area .single-option-selector', this.el).off('change.product');
    $('.product-main-image.zoom-enabled', this.el).off('click.product');
    $('.product-zoom', this.el).off('mouseout.product');
    $('.product-zoom', this.el).off('mousemove.product');
    $('.product-main-image', this.el).off('resetZoom.product');
  }

  _onVariantSwitch(product, variant) {
    if (product !== this.data.product) {
      return;
    }

    const { options } = variant;

    options.forEach((option, index) => {
      this.$options.eq(index).siblings('[data-selected-option]').text(option);
    });

    this._updatePrice(variant);
    this._updateImages(variant);
    this._updateHistory(variant);
  }

  _updateImages(variant) {
    const imageId = (variant.featured_image || this.data.product.featured_image).id;

    if (this.$productMainImage != null) {
      this.$productMainImage.trigger('resetZoom');
    }

    if (imageId == null) { return; }

    const $productThumbnails = $('.product-images .thumb img', this.productArea);

    $productThumbnails
      .filter(`[data-image-id='${imageId}']`)
      .parent()
      .trigger('click');
  }

  _updatePrice(variant) {
    const $addToCartButton = $('.product-submit-wrapper input', this.productArea);
    const $priceFields = $('.product-details .price, .mobile-product-title .price', this.productArea);

    if (variant) {
      for (let i = 0; i < $priceFields.length; i++) {
        const $moneyEl = $($priceFields[i]).children('.money');
        const { attributes } = $moneyEl[0];

        for (let j = 0; j < attributes.length; j++) {
          const attribute = attributes[j];

          if (attribute.name.indexOf('data-') > -1) {
            $moneyEl.attr(attribute.name, '');
          }
        }
      }

      if (variant.available) {
        $addToCartButton
          .val(this.data.productSettings.addToCartText)
          .removeClass('disabled')
          .removeAttr('disabled');
      } else {
        $addToCartButton
          .val(this.data.productSettings.soldOutText)
          .addClass('disabled')
          .attr('disabled', 'disabled');
      }

      if (variant.compare_at_price > variant.price) {
        $priceFields
          .find('.money:not(.original)')
          .html(Shopify.formatMoney(variant.price, Theme.moneyFormat))
          .attr(`data-currency-${Theme.currency}`, Shopify.formatMoney(variant.price, Theme.moneyFormat))
          .attr('data-currency', Theme.currency);
        $priceFields
          .find('.money.original')
          .html(Shopify.formatMoney(variant.compare_at_price, Theme.moneyFormat))
          .removeClass('hidden')
          .attr(`data-currency-${Theme.currency}`, Shopify.formatMoney(variant.compare_at_price, Theme.moneyFormat))
          .attr('data-currency', Theme.currency);
      } else {
        $priceFields
          .find('.money:not(.original)')
          .html(Shopify.formatMoney(variant.price, Theme.moneyFormat))
          .attr(`data-currency-${Theme.currency}`, Shopify.formatMoney(variant.price, Theme.moneyFormat))
          .attr('data-currency', Theme.currency);
        $priceFields
          .find('.money.original')
          .addClass('hidden')
          .attr(`data-currency-${Theme.currency}`, Shopify.formatMoney(variant.compare_at_price, Theme.moneyFormat))
          .attr('data-currency', Theme.currency);
      }
    } else {
      // Variant doesn't exist
      $addToCartButton
        .val(this.data.productSettings.unavailableText)
        .addClass('disabled')
        .attr('disabled', 'disabled');
    }

    if (Theme.currencySwitcher) {
      $(document.body).trigger('switch-currency');
    }
  }

  _updateHistory(variant) {
    if (!this.data.productSettings.enableHistory || (variant == null)) { return; }

    const newUrl = [
      window.location.protocol,
      '//',
      window.location.host,
      window.location.pathname,
      '?variant=',
      variant.id,
    ];

    const variantUrl = newUrl.join('');
    window.history.replaceState({ path: variantUrl }, '', variantUrl);
  }
}
